export const cols = [{
	prop: 'shopname',
	label: '店铺名称',
	width: '120',
	ischoose: false,
	align: 'center'
}, {
	prop: 'ordertype',
	label: '单据类型',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '单据编号',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'createdate',
	label: '下单时间',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'preparedate',
	label: '备货日期',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'wantarrivaldate',
	label: '到货日期',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerName',
	label: '客户名称',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerCode',
	label: '客户编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderstatus',
	label: '订单状态',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'pcode',
	label: '商品编号',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'matchCode',
	label: '第三方编号',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'packing',
	label: '包装清单',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'bigcategoryname',
	label: '店铺级大类',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'smallcategoryname',
	label: '店铺级小类',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'specCode',
	label: '规格编号',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'weight',
	label: '重量',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'punit',
	label: '基础单位',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'assistunit',
	label: '辅助单位',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'giftFlag',
	label: '是否赠品',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'discountMoney',
	label: '优惠额',
	width: '120',
	ischoose: false,
	align: 'center'
}, {
	prop: 'initialprice',
	label: '单价',
	width: '120',
	ischoose: false,
	align: 'center'
}, {
	prop: 'price',
	label: '实际单价',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'assistquantity',
	label: '辅助数量',
	width: '160',
	ischoose: false,
	align: 'center'
}, {
	prop: 'itemquantity',
	label: '订货数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendcount',
	label: '实发数量',
	width: '120',
	ischoose: true,
	align: 'right'
}, {
	prop: 'getcount',
	label: '实收数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffcount',
	label: '差发数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buydiffcount',
	label: '差收数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundquantity',
	label: '实退数量',
	ischoose: true,
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceivecount',
	label: '净收数量',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realmoney',
	label: '订货金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendmoney',
	label: '实发金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getmoney',
	label: '实收金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffmoney',
	label: '差发金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buydiffmoney',
	label: '差收金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundmoney',
	label: '实退金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceiveMoney',
	label: '净收金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'itemWeight',
	label: '订货重量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendWeight',
	label: '发货重量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'receiveWeight',
	label: '收货重量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'offlinemoney',
	label: '单据线下支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'onlinemoney',
	label: '单据微信支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'tenpayMoney',
	label: '单据微企付支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'preMoney',
	label: '单据预付货款金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayonlineMoney',
	label: '单据云资金-网商余额支付金额',
	width: '220',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayremittanceMoney',
	label: '单据云资金-汇付支付金额',
	width: '220',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayCITICMoney',
	label: '单据云资金-中信支付金额',
	width: '220',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
},
// {
// 	prop: 'cldpayFuYouAccMoney',
// 	label: '单据云资金-富友账户通支付金额',
// 	width: '220',
// 	ischoose: true,
// 	headerAlign: 'center',
// 	align: 'right'
// },
{
	prop: 'b2bwechatMoney',
	label: 'B2b门店助手-微信支付',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'b2bbankMoney',
	label: 'B2b门店助手-银行转账',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayCashierOnlineMoney',
	label: '云资金-网商收银台',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'cldpayLklSmbMoney',
	label: '拉卡拉全渠道-余额支付',
	width: '220',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
// }, {
// 	prop: 'cldpayCashierLklSmbMoney',
// 	label: '拉卡拉全渠道-收银台',
// 	width: '180',
// 	ischoose: true,
// 	headerAlign: 'center',
// 	align: 'right'
}, {
	prop: 'cldpayLklBalanceMoney',
	label: '拉卡拉钱包余额',
	width: '220',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
},
{
	prop: 'detailmemo',
	label: '单品备注',
	width: '180',
	// ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'memo',
	label: '买家备注',
	width: '180',
	// ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'systemmemo',
	label: '系统备注',
	width: '180',
	// ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sellermemo',
	label: '卖家备注',
	width: '180',
	// ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyername',
	label: '收货人',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buytel',
	label: '联系电话',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyeraddress',
	label: '收货地址',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'linename',
	label: '线路',
	width: '120',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'relatenumber',
	label: '关联单号',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'liquidateflag',
	label: '是否勾销',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'freight',
	label: '运费',
	width: '120',
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'usernames',
	label: '业务员',
	width: '120',
	headerAlign: 'center',
	align: 'center'
}]
// , {
// 	prop: 'companycode',
// 	label: '物流公司',
// 	width: '120',
// 	headerAlign: 'center',
// 	align: 'center'
// }, {
// 	prop: 'ffmnumber',
// 	label: '物流单号',
// 	width: '120',
// 	headerAlign: 'center',
// 	align: 'right'
// }
